import Vue from 'vue'
import md5 from 'js-md5'
import conifg from './config.js'
const axios = require('axios')
const port = '100921'
const key = 'bc85573d1fc58140'
const env = '/apien/' // 英文
const api = {
  /*
  * 登录
  */
  login: env + 'index.php/index/Admin/login',
  logout: env + 'index.php/index/Admin/logout',
  init: env + 'index.php/index/Index/init',
  // 首页业务范围
  cardRead: env + 'index.php/data/Card/read',
  /*
  * 图片模块
  */
  imageRead: env + 'index.php/data/Image/read',
  imageUpdate: env + 'index.php/data/Image/update',
  imageCreate: env + 'index.php/data/Image/create',
  imageDelete: env + 'index.php/data/Image/delete',
  imageCreateMany: env + 'index.php/data/Image/create_many',
  imageDeleteMany: env + 'index.php/data/Image/delete_many',
  /*
  * 文件上传
  */
  uploadMany: env + 'index.php/index/Oss/upload_many',
  ossDelete: env + 'index.php/index/Oss/delete',
  /*
  * 轮播图模块
  */
  slideRead: env + 'index.php/data/Slider/read',
  slideCreate: env + 'index.php/data/Slider/create',
  slideUpdate: env + 'index.php/data/Slider/update',
  slideUpdateMany: env + 'index.php/data/Slider/update_many',
  slideDelete: env + 'index.php/data/Slider/delete',
  /*
  * 客户管理
  */
  clientRead: env + 'index.php/data/Client/read',
  clientUpdateMany: env + 'index.php/data/Client/update_many',
  clientUpdate: env + 'index.php/data/Client/update',
  clientDelete: env + 'index.php/data/Client/delete',
  clientCreate: env + 'index.php/data/Client/create',
  /*
  * 团队管理
  */
  memberRead: env + 'index.php/data/Member/read',
  memberFind: env + 'index.php/data/Member/find',
  memberUpdateMany: env + 'index.php/data/Member/update_many',
  memberUpdate: env + 'index.php/data/Member/update',
  memberDelete: env + 'index.php/data/Member/delete',
  memberCreate: env + 'index.php/data/Member/create',
  /*
  * 新闻管理
  */
  newsRead: env + 'index.php/data/News/read',
  newsUpdateMany: env + 'index.php/data/News/update_many',
  newsUpdate: env + 'index.php/data/News/update',
  newsDelete: env + 'index.php/data/News/delete',
  newsCreate: env + 'index.php/data/News/create',
  newsFind: env + 'index.php/data/News/find',
  /*
  * 文章管理
  */
  articleRead: env + 'index.php/data/Article/read',
  articleFind: env + 'index.php/data/Article/find',
  articleUpdateMany: env + 'index.php/data/Article/update_many',
  articleUpdate: env + 'index.php/data/Article/update',
  articleDelete: env + 'index.php/data/Article/delete',
  articleCreate: env + 'index.php/data/Article/create',
  /*
  * 标签管理
  */
  tagRead: env + 'index.php/data/Tag/read',
  tagUpdate: env + 'index.php/data/Tag/update',
  tagCreate: env + 'index.php/data/Tag/create',
  tagCreateMany: env + 'index.php/data/Tag/create_many',
  tagDelete: env + 'index.php/data/Tag/delete',
  /**
   * 系统设置
   */
  configRead: env + 'index.php/data/Config/read',
  configUpdate: env + 'index.php/data/Config/update',
  configFind: env + 'index.php/data/Config/find',
  /*
  * 案例管理
  */
  casesRead: env + 'index.php/data/Cases/read',
  casesFind: env + 'index.php/data/Cases/find',
  casesUpdateMany: env + 'index.php/data/Cases/update_many',
  casesUpdate: env + 'index.php/data/Cases/update',
  casesDelete: env + 'index.php/data/Cases/delete',
  casesCreate: env + 'index.php/data/Cases/create',
  /*
  * 行业管理
  */
  industryRead: env + 'index.php/data/Industry/read',
  industryFind: env + 'index.php/data/Industry/find',
  industryUpdateMany: env + 'index.php/data/Industry/update_many',
  industryUpdate: env + 'index.php/data/Industry/update',
  industryDelete: env + 'index.php/data/Industry/delete',
  industryCreate: env + 'index.php/data/Industry/create',
  /*
  * 业务管理
  */
  businessRead: env + 'index.php/data/Business/read',
  businessFind: env + 'index.php/data/Business/find',
  businessUpdateMany: env + 'index.php/data/Business/update_many',
  businessUpdate: env + 'index.php/data/Business/update',
  businessDelete: env + 'index.php/data/Business/delete',
  businessCreate: env + 'index.php/data/Business/create',
  /*
  * 荣誉管理
  */
  honorRead: env + 'index.php/data/Honor/read',
  honorUpdateMany: env + 'index.php/data/Honor/update_many',
  honorUpdate: env + 'index.php/data/Honor/update',
  honorDelete: env + 'index.php/data/Honor/delete',
  honorCreate: env + 'index.php/data/Honor/create',
  /*
  * 大事记管理
  */
  eventRead: env + 'index.php/data/Event/read',
  eventUpdateMany: env + 'index.php/data/Event/update_many',
  eventUpdate: env + 'index.php/data/Event/update',
  eventDelete: env + 'index.php/data/Event/delete',
  eventCreate: env + 'index.php/data/Event/create'
}

/*
* 生成签名
*/
const getSignature = function () {
  let timestamp = Date.parse(new Date()).toString().substr(0, 10)
  let sign = md5(port + timestamp + key).toUpperCase()
  let obj = {
    sign: sign,
    port: port,
    time: timestamp
  }
  return obj
}
/*
* 设置Header
*/
const setHeader = function () {
  let obj = getSignature()
  axios.defaults.headers.common['PORT'] = obj.port
  axios.defaults.headers.common['SIGN'] = obj.sign
  axios.defaults.headers.common['TIMESTAMP'] = obj.time
  let token = localStorage.getItem(conifg.storage.token)
  if (token) {
    axios.defaults.headers.common['TOKEN'] = token
  }
}
/**
 * Get请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 */
Vue.prototype.get = function (param, callback) {
  setHeader()
  let query = param.data ? param.data : {}
  axios.get(api[param.url], {
    params: query
  }).then((res) => {
    callback(res.data)
  }).catch((err) => {
    console.log(err)
  })
}

/**
 * POST请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 */
Vue.prototype.post = function (param, callback) {
  setHeader()
  let query = param.data ? param.data : {}
  axios.post(api[param.url], query).then((res) => {
    callback(res.data)
  }).catch((err) => {
    console.log(err)
  })
}

/**
 * PUT请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 */
Vue.prototype.put = function (param, callback) {
  setHeader()
  let query = param.data ? param.data : {}
  axios.put(api[param.url], query).then((res) => {
    callback(res.data)
  }).catch((err) => {
    console.log(err)
  })
}

/**
 * DELETE请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 */
Vue.prototype.delete = function (param, callback) {
  setHeader()
  let query = param.data ? param.data : {}
  axios.delete(api[param.url], {
    params: query // data改为params即可
  }).then((res) => {
    callback(res.data)
  }).catch((err) => {
    console.log(err)
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js